import { TbArrowRight } from 'react-icons/tb'
import { Heading, Text } from 'ui-kit/typography'
import { SCENARIO_CONNECTORS_LIMIT } from 'routes/constants'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'
import NavLink from 'ui-kit/actions/link/NavLink'
import clsx from 'clsx'
import classes from './ScenarioCard.module.scss'

export const ScenariosCard = ({
  scenario,
  href,
  isVertical,
  className,
}: {
  scenario: ScenarioTemplateCompact
  href?: string
  isVertical?: boolean
  className?: string
}) => {
  const { name, shortDescription, connectors } = scenario

  return (
    <div className={clsx(classes.card, className)}>
      <div className={classes.content}>
        {href ? (
          <NavLink href={href} className={classes.link}>
            <Heading as={'h3'} size={'xs'} className={classes.title}>
              {name}
            </Heading>
            <TbArrowRight className={classes.icon} />
          </NavLink>
        ) : (
          <div className={classes.heading}>
            <Heading as={'h3'} size={'xs'} className={classes.title}>
              {name}
            </Heading>
            <TbArrowRight className={classes.icon} />
          </div>
        )}

        <Text size={'sm'} className={classes.description}>
          {shortDescription}
        </Text>
      </div>

      <ScenarioConnectors
        connectors={connectors}
        className={clsx(
          classes.partners,
          isVertical && classes.partners__vertical,
        )}
      />
    </div>
  )
}

const ScenarioConnectors = ({
  connectors = [],
  className,
}: {
  connectors: ScenarioTemplateCompact['connectors']
  className?: string
}) => {
  if (!connectors.length) return null

  const restConnectorsCount =
    connectors.length > SCENARIO_CONNECTORS_LIMIT + 1
      ? connectors.length - SCENARIO_CONNECTORS_LIMIT
      : 0

  const connectorsToShow =
    connectors.length === SCENARIO_CONNECTORS_LIMIT + 1
      ? connectors
      : connectors.slice(0, SCENARIO_CONNECTORS_LIMIT)

  return (
    <div className={clsx(classes.wrapper, className)}>
      <Text as={'span'} size={'sm'} className={classes.note}>
        Works with:
      </Text>

      <ul className={classes.connectors}>
        {connectorsToShow.map(({ logoUri, name }, idx) => {
          return (
            <li key={idx} className={classes.connector}>
              <img
                src={logoUri}
                alt={name}
                title={name}
                width={38}
                height={38}
                loading='lazy'
              />
            </li>
          )
        })}
        {restConnectorsCount > 0 && (
          <li
            key={SCENARIO_CONNECTORS_LIMIT}
            className={clsx(classes.connector, classes.connector__count)}
          >
            <Text as={'span'} size={'sm'} className={classes.count}>
              +{restConnectorsCount}
            </Text>
          </li>
        )}
      </ul>
    </div>
  )
}
